(function () {
    "use strict";

    angular
        .module("app")
        .factory("SharedData", function ($q, $localStorage, SeasonService, BrandService) {

            //declare/define data objects for sharing
            var data = {
                text: "",
                brandId: 0,
                seasonId: 0,
                divisionKey: "",
                useDefaultsInQuickSearch: false,
                trigger: 0
            };

            var userDefaults = {
                brandId: 0,
                seasonId: 0,
                divisionKey: "",
                useDefaultsInQuickSearch: false,
                seasons: [],
                brands: []
            };

            var promise = null;

            //get/set methods
            return {
                clear: function () {
                    userDefaults = {
                        brandId: 0,
                        seasonId: 0,
                        divisionKey: "",
                        useDefaultsInQuickSearch: false,
                        seasons: [],
                        brands: []
                    };
                    promise = null;
                },

                getRefreshTrigger: function () {
                    return data.trigger;
                },

                triggerRefresh: function () {
                    data.trigger++;
                },

                getBrandId: function () {
                    return data.brandId;
                },

                getSeasonId: function () {
                    return data.seasonId;
                },

                getDivisionKey: function () {
                    return data.divisionKey;
                },

                getUseDefaultsInQuickSearch: function () {
                    return data.useDefaultsInQuickSearch;
                },

                setBrandId: function (brandId) {
                    data.brandId = brandId;
                },

                setSeasonId: function (seasonId) {
                    data.seasonId = seasonId;
                },

                setDivisionKey: function (divisionKey) {
                    data.divisionKey = divisionKey;
                },

                setUseDefaultsInQuickSearch: function (useDefaultsInQuickSearch) {
                    data.useDefaultsInQuickSearch = useDefaultsInQuickSearch;
                },

                setUserDefaults: function (brandId, seasonId, divisionKey, useDefaultsInQuickSearch) {
                    userDefaults.brandId = brandId;
                    userDefaults.seasonId = seasonId;
                    userDefaults.divisionKey = divisionKey;
                    userDefaults.useDefaultsInQuickSearch = useDefaultsInQuickSearch;
                    promise = null;
                    //console.log('ANGULAR: sharedData setUserDefaults',brandId,seasonId);
                },

                getUserDefaults: function () {
                    var deferred = $q.defer();

                    //console.log('ANGULAR: getting user defaults',promise);
                    if (promise !== null)
                        return promise;

                    promise = deferred.promise;

                    var currentUser = $localStorage.currentUser;

                    var brandId = parseInt(currentUser.defaultBrandId);
                    var seasonId = parseInt(currentUser.defaultSeasonId);

                    userDefaults.divisionKey = currentUser.defaultDivisionKey;
                    userDefaults.useDefaultsInQuickSearch = currentUser.useDefaultsInQuickSearch === true;

                    if (!isNaN(brandId))
                        userDefaults.brandId = brandId;

                    if (!isNaN(seasonId))
                        userDefaults.seasonId = seasonId;

                    if (!userDefaults.divisionKey)
                        userDefaults.divisionKey = null;

                    BrandService.getBrandsByUser().then(function (brands) {
                        userDefaults.brands = brands;

                        if (userDefaults.brandId > 0) {
                            SeasonService.getSeasonsByBrand(userDefaults.brandId).then(function (seasons) {
                                userDefaults.seasons = seasons;

                                deferred.resolve(userDefaults);
                            });
                        } else {
                            deferred.resolve(userDefaults);
                        }
                    });

                    return promise;
                }
            };
        });
})();
